import {KOSubscriptionTracker} from "../../../../util/KOSubscriptionTracker";
import * as ko from "knockout";
import {ICompany, ILogin} from "../../../../index";
import {Permission} from "../../../../constants/Permission";
import {TCrudMode} from "..";
import {StatusManager} from "../StatusManager";
import {MutableCompany} from "../MutableCompany";

export abstract class AbstractMutableData {
    public readonly crudMode: KnockoutObservable<TCrudMode | null> = ko.observable(null)

    public readonly input_date: KnockoutObservable<string | null> = ko.observable(null)
    public minDate!: string
    public maxDate!: string

    public readonly isActive: KnockoutObservable<boolean | null> = ko.observable(null)
    protected readonly kosub = new KOSubscriptionTracker()

    abstract isChanged: KnockoutComputed<boolean>
    abstract isValid: KnockoutComputed<boolean>
    abstract getSubmitData: KnockoutComputed<ICompany>

    public readonly permission: KnockoutObservable<Permission>
    public readonly loginObj: ILogin
    public readonly mutableCompany: MutableCompany;

    constructor(protected readonly statusManager: StatusManager) {
        this.permission = statusManager.permission
        this.loginObj = statusManager.user!
        this.mutableCompany = statusManager.mutableCompany
    }

    protected init(): void {
        this.crudMode('read')
    }

    discard() {
        this.init()
    }

    public isCrudModeAvailable(mode: TCrudMode): boolean {
        switch (mode) {
            case 'read':
                return this.permission() >= Permission.SuperManager
            case 'write':
                return this.permission() >= Permission.CompanyAdmin
        }
    }

    dispose() {
        this.kosub.unsuscribeAll()
    }

}